import http from './api'
import { TopScorerEvent, TopScorerPrediction } from '../types/topScorer'

class TopScorerService {
  async getEvents(filters?: {
    league?: string
    isActive?: boolean
    upcomingOnly?: boolean
  }): Promise<TopScorerEvent[]> {
    const params = new URLSearchParams()
    if (filters?.league) params.append('league', filters.league)
    if (filters?.isActive !== undefined) params.append('isActive', String(filters.isActive))
    if (filters?.upcomingOnly === false) params.append('upcomingOnly', 'false')
    const qs = params.toString()
    const response = await http.get(`/top-scorer/events${qs ? `?${qs}` : ''}`)
    const data = response.data?.events ?? response.data
    return Array.isArray(data) ? data : []
  }

  async getEvent(eventId: string): Promise<TopScorerEvent> {
    const response = await http.get(`/top-scorer/events/${eventId}`)
    return response.data
  }

  async updateEvent(
    eventId: string,
    data: {
      name?: string
      league?: string
      eventDate?: string
      choices?: string[]
      points?: number
      isActive?: boolean
      actualTopScorer?: string
    },
  ): Promise<TopScorerEvent> {
    const response = await http.patch(`/top-scorer/events/${eventId}`, data)
    return response.data
  }

  async createPrediction(data: {
    roomId: string
    eventId: string
    predictedScorer: string
  }): Promise<TopScorerPrediction> {
    const response = await http.post('/top-scorer/predictions', data)
    return response.data
  }

  async getPlayerPredictions(roomId: string, playerId: string): Promise<TopScorerPrediction[]> {
    const response = await http.get(`/top-scorer/predictions/room/${roomId}/player/${playerId}`)
    const data = response.data?.predictions ?? response.data
    return Array.isArray(data) ? data : []
  }
}

const topScorerService = new TopScorerService()

export default topScorerService
